/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BadRequestResponse,
  GetTaskHistoryParams,
  TaskApiFailureResponseResponse,
  TaskApiForbiddenResponse,
  TaskApiUnauthorizedResponse,
  TaskHistoryResponseResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Get Task History
 */
export const getTaskHistory = (params?: GetTaskHistoryParams, signal?: AbortSignal) => {
  return customInstance<TaskHistoryResponseResponse>({
    url: `/BboTaskApi/v1/history`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetTaskHistoryQueryKey = (params?: GetTaskHistoryParams) => {
  return [`/BboTaskApi/v1/history`, ...(params ? [params] : [])] as const;
};

export const getGetTaskHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getTaskHistory>>,
  TError = ErrorType<
    | BadRequestResponse
    | TaskApiUnauthorizedResponse
    | TaskApiForbiddenResponse
    | TaskApiFailureResponseResponse
  >,
>(
  params?: GetTaskHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskHistory>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTaskHistoryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskHistory>>> = ({ signal }) =>
    getTaskHistory(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTaskHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTaskHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskHistory>>>;
export type GetTaskHistoryQueryError = ErrorType<
  | BadRequestResponse
  | TaskApiUnauthorizedResponse
  | TaskApiForbiddenResponse
  | TaskApiFailureResponseResponse
>;

/**
 * @summary Get Task History
 */
export const useGetTaskHistory = <
  TData = Awaited<ReturnType<typeof getTaskHistory>>,
  TError = ErrorType<
    | BadRequestResponse
    | TaskApiUnauthorizedResponse
    | TaskApiForbiddenResponse
    | TaskApiFailureResponseResponse
  >,
>(
  params?: GetTaskHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskHistory>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTaskHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
